"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
module.exports = {
    GoLocalStorage: require('./GoLocalStorage').GoLocalStorage,
    GoDropBox: require('./GoDropBox').GoDropBox,
    GoGoogleDrive: require('./GoGoogleDrive').GoGoogleDrive,
    GoOneDrive: require('./GoOneDrive').GoOneDrive,
    GoNetCore: require('./GoNetCore').GoNetCore,
    GoCloudStorageManager: require('./GoCloudStorageManager').GoCloudStorageManager
};
